import { Field } from '../../../../ui/Field'
import React from 'react'

export const CustomerAccount = ({ errors, account, OnValueChange }) => (
  <>
    <Field
      name="contacts"
      error={errors['contacts']}
      className="mb-3"
      required
      defaultValue={account.contacts}
      onChange={(e) => OnValueChange(e.target)}
    >
      Contact
    </Field>

    <Field
      name="email"
      error={errors['email']}
      className="mb-3"
      type="email"
      defaultValue={account.email}
      onChange={(e) => OnValueChange(e.target)}
      required
    >
      Email
    </Field>

    <Field
      name="password"
      error={errors['password']}
      className="mb-3"
      type="password"
      defaultValue={account.password}
      onChange={(e) => OnValueChange(e.target)}
    >
      Password
    </Field>

    <Field
      name="password_confirmation"
      type="password"
      error={errors['password_confirmation']}
      className="mb-3"
      defaultValue={account.password_confirmation}
      onChange={(e) => OnValueChange(e.target)}
    >
      password confirmation
    </Field>
  </>
)
